import { __decorate } from "tslib";
import { __metadata } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Input } from "@angular/core";
import { AppState } from "../../app.service";
import { BasketAssistant } from "@api/services/basket";
import { formatEuro, getPromoSubprices } from "@api/utils";
var TotalCostsComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function TotalCostsComponent(appState) {
        this.appState = appState;
        /**
         * Set our default values
         */
        this.localState = { value: "" };
        this.basketItems = [];
        this.monthlyCosts = 0;
        this.onetimeCosts = 0;
        this.formatEuro = formatEuro;
        this.insurancesAmount = 0;
        this.insurancesCost = 0;
        this.promoSubpriceLabels = "";
        this.promoSubprices = "";
        this.loadBasketItems = this.loadBasketItems.bind(this);
    }
    TotalCostsComponent.prototype.ngOnInit = function () {
        this.loadBasketItems();
        BasketAssistant.subscribe("itemsDeleted", this.loadBasketItems);
        BasketAssistant.subscribe("itemsAdded", this.loadBasketItems);
        var checkoutContainer = document.getElementsByTagName("vfeo-checkout");
        this.vat = checkoutContainer[0].getAttribute("data-vat");
    };
    TotalCostsComponent.prototype.loadBasketItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, monthlyCosts, onetimeCosts, insurancesAmount, insurancesCost, promos, key, subprices, _i, subprices_1, subprice, promo, basketItem, cummulatedPromoSubPrice, promo;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        _a.basketItems = (_b.sent());
                        monthlyCosts = 0;
                        onetimeCosts = 0;
                        insurancesAmount = 0;
                        insurancesCost = 0;
                        promos = {};
                        for (key in this.basketItems) {
                            if (this.basketItems[key].offer.insuranceOption.length) {
                                insurancesAmount += this.basketItems[key].amount;
                                insurancesCost +=
                                    this.basketItems[key].amount *
                                        this.basketItems[key].offer.getInsurancePrice();
                            }
                            monthlyCosts +=
                                this.basketItems[key].offer.getMonthlyPrice() *
                                    this.basketItems[key].amount;
                            onetimeCosts +=
                                this.basketItems[key].offer.getOnetimePrice() *
                                    this.basketItems[key].amount;
                            onetimeCosts +=
                                this.basketItems[key].offer.getActivationFee() *
                                    this.basketItems[key].amount;
                            subprices = getPromoSubprices(this.basketItems[key].offer);
                            for (_i = 0, subprices_1 = subprices; _i < subprices_1.length; _i++) {
                                subprice = subprices_1[_i];
                                if (!promos[subprice.runtime]) {
                                    promos[subprice.runtime] = 0;
                                }
                            }
                        }
                        for (promo in promos) {
                            for (basketItem in this.basketItems) {
                                promos[promo] +=
                                    this.basketItems[basketItem].offer.getMonthlyPriceAfterNMonths(promo) *
                                        this.basketItems[basketItem].amount;
                            }
                        }
                        this.promoSubpriceLabels = "";
                        this.promoSubprices = "";
                        cummulatedPromoSubPrice = 0;
                        for (promo in promos) {
                            cummulatedPromoSubPrice = promos[promo];
                            if (parseInt(promo) < 24 && parseInt(promo) > 2) {
                                this.promoSubpriceLabels = this.promoSubpriceLabels + " Ab dem " + promo + ". Monat <br>";
                                this.promoSubprices = this.promoSubprices + " " + formatEuro(cummulatedPromoSubPrice) + " <br>";
                            }
                        }
                        this.monthlyCosts = monthlyCosts;
                        this.onetimeCosts = onetimeCosts;
                        this.insurancesAmount = insurancesAmount;
                        this.insurancesCost = insurancesCost;
                        return [2 /*return*/];
                }
            });
        });
    };
    TotalCostsComponent.prototype.submitState = function (value) { };
    TotalCostsComponent.prototype.handleSubmit = function () {
        this.onSubmitRequest();
    };
    return TotalCostsComponent;
}());
export { TotalCostsComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/total-costs/total-costs.component.ts
// module id = null
// module chunks = 